import camelcase from 'camelcase';
import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export const mailLabelTypeSchema = z.pipe(
  z.literal([
    'nurse_ping',
    'nurse_to_doctor',
    'patient_to_nurse',
    'doctor_to_nurse',
    'dg_no_insulin_patient_to_doctor',
    'patient_expires_soon',
    'patient_expires_soon_nurse',
  ]),
  z.transform(data => camelcase(data)),
);

export type MailLabelType = z.infer<typeof mailLabelTypeSchema>;

export type MailPreference = {
  id: string;
  enabled: boolean;
  label: MailLabelType;
};

export const mailPreferenceSchema: Schema<MailPreference> = z.object({
  id: cz.id(),
  enabled: z.boolean(),
  label: mailLabelTypeSchema,
});

export type MailPreferenceUpdate = {
  id: string;
  enabled: boolean;
};

export const mailPreferencePriority = (mail: MailPreference): number => {
  switch (mail.label) {
    case 'nursePing':
      return 0;
    case 'nurseToDoctor':
    case 'doctorToNurse':
      return 1;
    case 'patientToNurse':
      return 2;
    case 'patientExpiresSoon':
    case 'patientExpiresSoonNurse':
      return 3;
    case 'dgNoInsulinPatientToDoctor':
      return 4;
  }
};

export const compareMailPreference = (a: MailPreference, b: MailPreference) => {
  return mailPreferencePriority(a) - mailPreferencePriority(b);
};
